export default __webpack_public_path__ + "static/media/863.9f0ff2f6.png";